// Internal Imports
import { getBabbelBaseUrl } from './url.js';

// Local Functions
const discoverDeeplinkUrl = (learnLanguageAlpha3, locale) =>
  `${getBabbelBaseUrl()}/deeplinks/${locale}/learn_languages/${learnLanguageAlpha3}/discover`;

// Module Exports
export { discoverDeeplinkUrl };
